import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import TextInput from "../../components/forms/TextInput";
import { useAuth } from "../../js/hooks/useAuth";
import { validateLogin } from "../../js/utils/validators";
import { resolvePostAuthPath } from "../../js/auth/onboardingState";
import { toTitleCase } from "../../js/utils/titleCase";
import LifecycleLoginNote from "../../components/account/LifecycleLoginNote";
import { REPTC_POWERED } from "../../js/utils/reptc";
export default function AgentLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [lifeError, setLifeError] = useState(null);

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    const nextErrors = validateLogin(form);
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;
    try {
      setLifeError(null);
      const session = await login(form, "agent");
      navigate(session?.role === "admin" ? "/admin" : resolvePostAuthPath(session, "agent"));
    } catch (error) {
      setMessage(error.message);
      setLifeError(error);
    }
  }

  return (
    <AppLayout variant="public">
      <div className="card auth-card" data-tour="auth-card">
        <h1>{toTitleCase("Agent login")}</h1>
        <p className="page-lead">Sign in to your agent desk.</p>
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="auth-signin-row">
            <TextInput
              label="Email"
              name="email"
              type="email"
              value={form.email}
              onChange={update}
              error={errors.email}
              autoComplete="username"
            />
            <TextInput
              label="Password"
              name="password"
              type="password"
              value={form.password}
              onChange={update}
              error={errors.password}
              autoComplete="current-password"
            />
          </div>
          {message ? <p className="field-error">{message}</p> : null}
          <LifecycleLoginNote
            error={lifeError}
            form={form}
            onReactivated={() => handleSubmit({ preventDefault() {} })}
          />
          <button type="submit" className="primary-btn btn-block">
            Sign in
          </button>
        </form>
        <p className="auth-switch muted">
          <Link to="/register?role=agent">New Here?</Link>
        </p>
        <p className="muted">
          <Link to="/login">Buyer sign in</Link>
          {" · "}
          <Link to="/broker/login">broker login</Link>.
        </p>
        <p className="reptc-powered">{REPTC_POWERED}</p>
      </div>
    </AppLayout>
  );
}
